// extracted by mini-css-extract-plugin
module.exports = {"bannerWrapper":"_1igMMP1s101rKAPU6UyXZk"};